import { initializeApp } from "firebase/app";

import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { initializeFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBNXYIwrcJWzIdyDuOicGp5-AaZ0RlVDwg",
  // apiKey: "AIzaSyCp2nGw51j2TZCJ5pJMhdNqJto3yR-91Uk",
  authDomain: "mailcinemaotp.firebaseapp.com",
  projectId: "mailcinemaotp",
  storageBucket: "mailcinemaotp.firebasestorage.app",
  messagingSenderId: "277545524113",
  appId: "1:277545524113:web:5830f29d1a97926a4b5830",
  measurementId: "G-9L97WZ4TKJ",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const storage = getStorage(app);
// export const db = getFirestore(app);

const firestoreTransport =
  process.env.REACT_APP_FIRESTORE_TRANSPORT === "default"
    ? "default"
    : "long-polling";

export const db = initializeFirestore(
  app,
  firestoreTransport === "default"
    ? {}
    : {
        experimentalForceLongPolling: true,
        useFetchStreams: false,
      }
);

if (process.env.NODE_ENV !== "production") {
  console.info("[firebase] firestore.transport", { firestoreTransport });
}
